import { RangeDateInput } from '@core/components/Inputs';
import { SimpleTableBase } from '@core/components/Table';
import { TableActionButtonDelete } from '@core/components/TableAction';
import { DataBR } from '@format/DATA';
import { Button, Typography } from '@material-ui/core';
import { getCurrency } from 'app/utils/monetarioUtil';
import React, { useContext, useEffect } from 'react';
import { ContaReceberRecorrenciaContext } from '../contaReceberRecorrenciaContext';
import { recorrenciaStyles } from './recorrenciaStyles';

const ContaReceberRecorrenciaTable = ({ fetchRecorrencias, handleDeleteRecorrencia }) => {
  const classes = recorrenciaStyles();

  const [recorrencias] = useContext(ContaReceberRecorrenciaContext).recorrencias;
  const [selecao, setSelecao] = useContext(ContaReceberRecorrenciaContext).selecao;
  const [tipoSelecao, setTipoSelecao] = useContext(ContaReceberRecorrenciaContext).tipoSelecao;
  const [totalElements] = useContext(ContaReceberRecorrenciaContext).totalElements;
  const [loading] = useContext(ContaReceberRecorrenciaContext).loading;
  const [page, setPage] = useContext(ContaReceberRecorrenciaContext).page;
  const [size, setSize] = useContext(ContaReceberRecorrenciaContext).size;
  const [sort, setSort] = useContext(ContaReceberRecorrenciaContext).sort;
  const [dataVencimentoInicio, setDataVencimentoInicio] = useContext(
    ContaReceberRecorrenciaContext
  ).dataVencimentoInicio;
  const [dataVencimentoFim, setDataVencimentoFim] = useContext(ContaReceberRecorrenciaContext).dataVencimentoFim;

    useEffect(() => {
      fetchRecorrencias({
        page,
        size,
        sort,
        dataVencimentoInicio: dataVencimentoInicio?.format('YYYY-MM-DD'),
        dataVencimentoFim: dataVencimentoFim?.format('YYYY-MM-DD'),
      });
      // Memoização intencional: as funções/props são recriadas a cada render e incluí-las
      // anularia o memo; o estado que elas leem já está nas dependências.
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

  const columns = [
    {
      name: 'dataVencimento',
      title: 'Vencimento',
      getCellValue: (data) => {
        return <div>{DataBR(data.dataVencimento)}</div>;
      },
      hideTooltip: true,
    },
    {
      name: 'cliente.pessoa.nome',
      title: 'Cliente',
      getCellValue: (data) => data.nomeCliente,
    },
    {
      name: 'valorBruto',
      title: 'Valor (R$)',
      align: 'right',
      getCellValue: (data) => getCurrency(data.valor),
    },
    {
      name: '',
      title: '',
      align: 'center',
      sortingEnabled: false,
      getCellValue: (data) => (
        <TableActionButtonDelete
          onClick={() => {
            handleDeleteRecorrencia(data);
          }}
        />
      ),
    },
  ];

  const onFetchData = (params) => {
    fetchRecorrencias(params);
  };

  return (
    <div className={classes.container}>
      <div className={classes.periodoVencimentoContainer}>
        <RangeDateInput
          id="periodo.dataVencimentoInicio"
          value={[dataVencimentoInicio, dataVencimentoFim]}
          label="Período do vencimento "
          onChange={(inicio, fim) => {
            setDataVencimentoInicio(inicio);
            setDataVencimentoFim(fim);
          }}
        />
        <Button
          className={classes.buttonSave}
          onClick={() => {
            fetchRecorrencias({
              page,
              size,
              sort,
              dataVencimentoInicio: dataVencimentoInicio?.format('YYYY-MM-DD'),
              dataVencimentoFim: dataVencimentoFim?.format('YYYY-MM-DD'),
            });
          }}
        >
          <Typography>Buscar</Typography>
        </Button>
      </div>
      <SimpleTableBase
        pageType="async"
        defaultSorting={[{ columnName: 'dataVencimento', direction: 'DESC' }]}
        columns={columns}
        rows={recorrencias}
        loading={loading}
        totalCount={totalElements}
        searchBy=""
        fetchData={onFetchData}
        onSelectionChange={setSelecao}
        onCurrentPageChange={setPage}
        onPageSizeChange={setSize}
        onSortingChange={setSort}
        selection={selecao}
        selectionType={tipoSelecao}
        onSelectionTypeChange={setTipoSelecao}
      />
    </div>
  );
};

export default ContaReceberRecorrenciaTable;
